<div class="content-tab">
  <h1 class="mb-3 title-overview">General informations</h1>

  <form>
    <div class="row card-info">
      <h3 class="mb-3 subtitle">Personal informations</h3>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="lastName">
            Last name
          </label>
          {{
            patientProfile.lastName !== null && patientProfile.lastName !== ""
              ? patientProfile.lastName
              : "Not specified"
          }}
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="firstName">
            First name
          </label>
          {{
            patientProfile.firstName !== null && patientProfile.lastName !== ""
              ? patientProfile.firstName
              : "Not specified"
          }}
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="gender">
            Gender
          </label>
          <ng-container
            *ngIf="patientProfile.gender === null; else genderValue"
          >
            Not specified
          </ng-container>
          <ng-template #genderValue>
            <ng-container *ngIf="patientProfile.gender === 'male'"
              >Male</ng-container
            >
            <ng-container *ngIf="patientProfile.gender === 'female'"
              >Female</ng-container
            >
          </ng-template>
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="dominantHand">
            Dominant hand
          </label>
          <ng-container
            *ngIf="
              patientProfile.dominantHand === null ||
                patientProfile.dominantHand === '';
              else dominantHandValue
            ">
            Not specified
          </ng-container>
          <ng-template #dominantHandValue>
            <ng-container *ngIf="patientProfile.dominantHand === 'left'">Left hand</ng-container>
            <ng-container *ngIf="patientProfile.dominantHand === 'right'">Right hand</ng-container>
          </ng-template>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="birthdate">
            Birthdate
          </label>
          {{
            patientProfile.birthDate !== null
              ? patientProfile.birthDate
              : 'Not specified'
          }}
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="height">
            Taille
          </label>
          {{
            patientProfile.height !== null
              ? patientProfile.height + " cm"
              : 'Not specified'
          }}
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="weight">
            Poids
          </label>
          {{
            patientProfile.weight !== null
              ? patientProfile.weight + " kg"
              : 'Not specified'
          }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="mb-3 subtitle">
          Activity
        </h3>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="educationLevel">
            Study level
          </label>
          {{
            patientProfile.educationLevel !== null
              ? educationLevelMapping[patientProfile.educationLevel]
              : 'Not specified'
          }}
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="professionalActivity">
            Professional status
          </label>
          {{
            patientProfile.professionalActivity !== null
              ? professionalActivityMapping[patientProfile.professionalActivity]
              : 'Not specified'
          }}
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="workTime">
            Full time job
          </label>
          <ng-container
            *ngIf="
              patientProfile.isFullTimeActivity === null;
              else isFullTimeActivityValue
            "
          >
            Not specified
          </ng-container>
          <ng-template #isFullTimeActivityValue>
            { patientProfile.isFullTimeActivity, select, true { yes } false { no } }
          </ng-template>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <h3 class="mb-3 subtitle">
          Carers and environments
        </h3>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="liveWithCaregiver">
            Carers
          </label>
          <ng-container
            *ngIf="
              patientProfile.liveWithCaregiver === null;
              else liveWithCaregiverValue
            ">
            Not specified
          </ng-container>
          <ng-template #liveWithCaregiverValue>
            {  patientProfile.liveWithCaregiver, select, true { yes }, false, { no } }
          </ng-template>
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="caregiverRelation">
            Link with carer
          </label>
          {{
            patientProfile.caregiverRelation !== null
              ? caregiverRelationMapping[patientProfile.caregiverRelation]
              : 'Not specified'
          }}
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="childrenCount">
            Children
          </label>
          {{
            patientProfile.childrenCount !== null &&
            patientProfile.childrenCount !== ""
              ? patientProfile.childrenCount
              : 'Not specified'
          }}
        </div>
      </div>
    </div>
  </form>
</div>
